export default {
  badge: 'شارة',
  close: 'إغلاق',
  dataIterator: {
    noResultsText: 'لم يتم إيجاد نتائج',
    loadingText: 'يتم جلب العناصر...',
  },
  dataTable: {
    itemsPerPageText: 'عدد الصفوف لكل صفحة:',
    ariaLabel: {
      sortDescending: 'مرتب تنازلياً.',
      sortAscending: 'مرتب تصاعدياً.',
      sortNone: 'غير مرتب.',
      activateNone: 'نشط لإزالة الترتيب.',
      activateDescending: 'نشط للترتيب تنازلياً.',
      activateAscending: 'نشط للترتيب تصاعدياً.',
    },
    sortBy: 'رتب حسب',
  },
  dataFooter: {
    itemsPerPageText: 'عدد العناصر لكل صفحة:',
    itemsPerPageAll: 'الكل',
    nextPage: 'الصفحة التالية',
    prevPage: 'الصفحة السابقة',
    firstPage: 'الصفحة الأولى',
    lastPage: 'الصفحة الأخيرة',
    pageText: '{0}-{1} من {2}',
  },
  datePicker: {
    itemsSelected: 'تم تحديد {0}',
    nextMonthAriaLabel: 'الشهر القادم',
    nextYearAriaLabel: 'العام القادم',
    prevMonthAriaLabel: 'الشهر الماضى',
    prevYearAriaLabel: 'السنة الماضية',
  },
  noDataText: 'لا توجد بيانات',
  carousel: {
    prev: 'المعروض السابق',
    next: 'المعروض التالي',
    ariaLabel: {
      delimiter: 'المعروض رقم {0} من {1}',
    },
  },
  calendar: {
    moreEvents: '{0} أكثر',
  },
  input: {
    clear: 'Clear {0}',
    prependAction: '{0} prepended action',
    appendAction: '{0} appended action',
  },
  fileInput: {
    counter: '{0} ملفات',
    counterSize: '{0} ملفات ({1} في المجموع)',
  },
  timePicker: {
    am: 'صباحاً',
    pm: 'مساءً',
  },
  pagination: {
    ariaLabel: {
      wrapper: 'الإنتقال بين الصفحات',
      next: 'الصفحة التالية',
      previous: 'الصفحة السابقة',
      page: '{0} انتقل إلى الصفحة',
      currentPage: '{0} الصفحة الحالية رقمها',
    },
  },
  rating: {
    ariaLabel: {
      icon: 'القييم {0} من {1}',
    },
  },
  loading: 'Loading...',
}
